import { ref, unref } from "vue";
import * as bankApi from "src/api/bank";
import { ifsc as ifscCode } from "src/assets/scripts/utilities/validationRules";

export function useBankVerification(formData, formState = null) {
  const bankVerificationLoading = ref(false);
  const bankVerificationError = ref("");

  const verifyBankAccount = async () => {
    const form = unref(formData);
    const accountNumber = form.account_number;
    const ifsc = form.ifsc_code;

    bankVerificationError.value = "";

    form.status_cd = "unverified";

    if (!unref(formState)?.edit) {
      form.bank_beneficiary_name = "";

      form.reason = "";
    }

    if (
      !accountNumber ||
      !ifsc ||
      !/^\d{9,17}$/.test(accountNumber) ||
      ifsc.length !== 11 ||
      !ifscCode(ifsc)
    ) {
      bankVerificationLoading.value = false;

      return;
    }

    bankVerificationLoading.value = true;

    try {
      const response = await bankApi.postVerifyBank({
        account_number: accountNumber,
        ifsc_code: ifsc,
      });

      const verification = response?.data?.data;

      const isBankActive =
        verification?.bankActive === true && !!verification?.beneName;

      form.reason = verification?.reason || "";

      if (isBankActive) {
        form.bank_beneficiary_name = verification.beneName;

        form.status_cd = "verified";
      } else {
        bankVerificationError.value =
          form.reason || "Unable to verify bank account.";
      }
    } catch (error) {
      console.error(error);

      if (!unref(formState)?.edit) {
        form.bank_beneficiary_name = "";

        form.reason = "";
      }

      form.status_cd = "unverified";

      form.reason =
        error?.response?.data?.data?.reason ||
        error?.response?.data?.message ||
        "";

      bankVerificationError.value =
        form.reason || "Unable to verify bank account.";
    } finally {
      bankVerificationLoading.value = false;
    }
  };

  return {
    verifyBankAccount,
    bankVerificationLoading,
    bankVerificationError,
  };
}
